import * as RadixSelect from '@radix-ui/react-select'
import { cx } from 'class-variance-authority'
import React, { forwardRef, useContext } from 'react'

import { InputField, InputFieldContext } from '../InputField/InputField'

import styles from './SelectInput.module.scss'

// *************************************************************
// TODO: Use icons from the package
// *************************************************************

const CheckmarkIcon = () => (
  <svg
    fill="none"
    height="12"
    viewBox="0 0 12 12"
    width="12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      height="13"
      id="mask0_1440_1692"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'alpha' }}
      width="13"
      x="0"
      y="0"
    >
      <rect
        fill="var(--gray-a12)"
        height="12"
        width="12"
        x="0.211914"
        y="0.00415039"
      />
    </mask>
    <g mask="url(#mask0_1440_1692)">
      <path
        d="M4.98702 7.57915L9.22452 3.34165C9.32452 3.24165 9.44118 3.19165 9.57452 3.19165C9.70785 3.19165 9.82452 3.24165 9.92452 3.34165C10.0245 3.44165 10.0745 3.5604 10.0745 3.6979C10.0745 3.8354 10.0245 3.95415 9.92452 4.05415L5.33702 8.65415C5.23702 8.75415 5.12035 8.80415 4.98702 8.80415C4.85368 8.80415 4.73702 8.75415 4.63702 8.65415L2.48702 6.50415C2.38702 6.40415 2.3391 6.2854 2.34327 6.1479C2.34743 6.0104 2.39952 5.89165 2.49952 5.79165C2.59952 5.69165 2.71827 5.64165 2.85577 5.64165C2.99327 5.64165 3.11202 5.69165 3.21202 5.79165L4.98702 7.57915Z"
        fill="var(--gray-a12)"
        fillOpacity="0.89"
      />
    </g>
  </svg>
)

const ChevronDownIcon = () => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5203 14.174L8.369 11.023C8.32567 10.9795 8.2915 10.9309 8.2665 10.8773C8.2415 10.8238 8.229 10.7663 8.229 10.705C8.229 10.5825 8.27042 10.476 8.35325 10.3855C8.43609 10.2952 8.54525 10.25 8.68075 10.25H15.3193C15.4548 10.25 15.5639 10.2957 15.6468 10.387C15.7296 10.4782 15.771 10.5846 15.771 10.7063C15.771 10.7368 15.7243 10.8423 15.6308 11.023L12.4798 14.174C12.4074 14.2465 12.3326 14.2994 12.2553 14.3327C12.1779 14.3661 12.0928 14.3828 12 14.3828C11.9072 14.3828 11.8221 14.3661 11.7448 14.3327C11.6674 14.2994 11.5926 14.2465 11.5203 14.174Z"
      fill="var(--gray-a11)"
      fillOpacity="1"
    />
  </svg>
)

const ClearIcon = () => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      height="17"
      id="mask0_2152_4138"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'alpha' }}
      width="17"
      x="-1"
      y="-1"
    >
      <rect
        fill="currentColor"
        height="16"
        width="16"
        x="-0.090332"
        y="-0.200195"
      />
    </mask>
    <g mask="url(#mask0_2152_4138)">
      <path
        d="M7.9095 8.50214L9.95817 10.551C10.0505 10.6432 10.1666 10.6904 10.3063 10.6926C10.446 10.6948 10.5642 10.6475 10.6608 10.551C10.7574 10.4543 10.8057 10.3372 10.8057 10.1996C10.8057 10.0621 10.7574 9.94497 10.6608 9.84831L8.61201 7.79964L10.6608 5.75098C10.7531 5.65864 10.8003 5.54259 10.8025 5.40281C10.8046 5.26314 10.7574 5.14497 10.6608 5.04831C10.5642 4.95175 10.4471 4.90347 10.3095 4.90347C10.1719 4.90347 10.0548 4.95175 9.95817 5.04831L7.9095 7.09714L5.86084 5.04831C5.7685 4.95609 5.65245 4.90886 5.51267 4.90664C5.37301 4.90453 5.25484 4.95175 5.15817 5.04831C5.06162 5.14497 5.01334 5.26209 5.01334 5.39964C5.01334 5.5372 5.06162 5.65431 5.15817 5.75098L7.20701 7.79964L5.15817 9.84831C5.06595 9.94064 5.01873 10.0567 5.01651 10.1965C5.01439 10.3361 5.06162 10.4543 5.15817 10.551C5.25484 10.6475 5.37195 10.6958 5.50951 10.6958C5.64706 10.6958 5.76417 10.6475 5.86084 10.551L7.9095 8.50214ZM7.91067 14.133C7.03467 14.133 6.21128 13.9668 5.4405 13.6343C4.66973 13.3019 3.99928 12.8507 3.42917 12.2808C2.85906 11.7109 2.40767 11.0408 2.07501 10.2703C1.74245 9.49986 1.57617 8.6767 1.57617 7.80081C1.57617 6.92481 1.74239 6.10142 2.07484 5.33064C2.40728 4.55986 2.85845 3.88942 3.42834 3.31931C3.99823 2.7492 4.66839 2.29781 5.43884 1.96514C6.20928 1.63259 7.03245 1.46631 7.90834 1.46631C8.78434 1.46631 9.60773 1.63253 10.3785 1.96497C11.1493 2.29742 11.8197 2.74859 12.3898 3.31848C12.9599 3.88836 13.4113 4.55853 13.744 5.32898C14.0766 6.09942 14.2428 6.92259 14.2428 7.79847C14.2428 8.67447 14.0766 9.49786 13.7442 10.2686C13.4117 11.0394 12.9606 11.7099 12.3907 12.28C11.8208 12.8501 11.1506 13.3015 10.3802 13.6341C9.60973 13.9667 8.78656 14.133 7.91067 14.133Z"
        fill="var(--gray-a11)"
        fillOpacity="1"
      />
    </g>
  </svg>
)

interface SelectOption {
  value: string
  label: string
}

interface SelectGroup {
  label: string
  options: SelectOption[]
}

const isSelectGroup = (item: SelectOption | SelectGroup): item is SelectGroup =>
  'options' in item

interface SelectInputProps {
  options: (SelectOption | SelectGroup)[]
  className?: string
  disabled?: boolean
  value?: string
  defaultValue?: string
  onChange?: (value: string) => void
  placeholder?: string
  name?: string
  required?: boolean
  form?: string
  open?: boolean
  defaultOpen?: boolean
  onOpenChange?: (open: boolean) => void
  onEscapeKeyDown?: (event: React.KeyboardEvent) => void
  onBlur?: (event: React.FocusEvent<HTMLButtonElement>) => void
  onFocus?: (event: React.FocusEvent<HTMLButtonElement>) => void
  clearable?: boolean
  onClear?: () => void
}

const Select = forwardRef<HTMLButtonElement, SelectInputProps>(
  (
    {
      className,
      disabled,
      options,
      value,
      defaultValue,
      onChange,
      placeholder,
      name,
      required,
      form,
      open,
      defaultOpen,
      onOpenChange,
      onEscapeKeyDown,
      onBlur,
      onFocus,
      clearable,
      onClear,
      ...props
    },
    ref
  ) => {
    const context = useContext(InputFieldContext)

    if (!context)
      throw new Error('SelectInput.Select must be used within InputField.Root')

    const handleClear = (e: React.MouseEvent) => {
      e.stopPropagation()
      onChange?.('')
      onClear?.()

      const triggerElement = e.currentTarget.parentElement?.querySelector(
        '[role="combobox"]'
      ) as HTMLButtonElement

      triggerElement?.focus()
    }

    return (
      <RadixSelect.Root
        defaultOpen={defaultOpen}
        defaultValue={defaultValue}
        disabled={disabled || context.disabled || context.readOnly}
        name={name}
        onOpenChange={onOpenChange}
        onValueChange={onChange}
        open={open}
        required={required}
        value={value}
        {...props}
      >
        <div className={styles.SelectInputWrapper}>
          <RadixSelect.Trigger
            aria-describedby={
              context.hasValidation ? context.validationId : undefined
            }
            aria-disabled={disabled || context.disabled || context.readOnly}
            aria-invalid={context.error}
            className={cx(styles.SelectInputTrigger, className)}
            form={form}
            id={context.id}
            onBlur={onBlur}
            onFocus={onFocus}
            onKeyDown={onEscapeKeyDown}
            ref={ref}
          >
            <RadixSelect.Value placeholder={placeholder} />
            <RadixSelect.Icon className={styles.SelectInputIcon}>
              <ChevronDownIcon />
            </RadixSelect.Icon>
          </RadixSelect.Trigger>
          {clearable && (value || defaultValue) && (
            <button
              aria-label="Clear selection"
              className={styles.SelectInputClearButton}
              onClick={handleClear}
              type="button"
            >
              <ClearIcon />
            </button>
          )}
        </div>

        <RadixSelect.Portal>
          <RadixSelect.Content
            align="start"
            className={styles.SelectInputContent}
            position="popper"
            sideOffset={2}
          >
            <RadixSelect.Viewport className={styles.SelectInputViewport}>
              {options.map((item) =>
                isSelectGroup(item) ? (
                  <RadixSelect.Group key={item.label}>
                    <RadixSelect.Label className={styles.SelectInputGroupLabel}>
                      {item.label}
                    </RadixSelect.Label>
                    {item.options.map((option) => (
                      <RadixSelect.Item
                        className={styles.SelectInputItem}
                        key={option.value}
                        value={option.value}
                      >
                        <RadixSelect.ItemText>
                          {option.label}
                        </RadixSelect.ItemText>
                        <RadixSelect.ItemIndicator
                          className={styles.SelectInputItemIndicator}
                        >
                          <CheckmarkIcon />
                        </RadixSelect.ItemIndicator>
                      </RadixSelect.Item>
                    ))}
                  </RadixSelect.Group>
                ) : (
                  <RadixSelect.Item
                    className={styles.SelectInputItem}
                    key={item.value}
                    value={item.value}
                  >
                    <RadixSelect.ItemText>{item.label}</RadixSelect.ItemText>
                    <RadixSelect.ItemIndicator
                      className={styles.SelectInputItemIndicator}
                    >
                      <CheckmarkIcon />
                    </RadixSelect.ItemIndicator>
                  </RadixSelect.Item>
                )
              )}
            </RadixSelect.Viewport>
          </RadixSelect.Content>
        </RadixSelect.Portal>
      </RadixSelect.Root>
    )
  }
)

Select.displayName = 'SelectInput.Select'

export const SelectInput = {
  Root: InputField.Root,
  Container: InputField.Container,
  Label: InputField.Label,
  Select,
  Validation: InputField.Validation,
  HelperText: InputField.HelperText,
  AffixContainer: InputField.AffixContainer,
  Prefix: InputField.Prefix,
  Suffix: InputField.Suffix
}
